import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => {
  const primary = theme.palette.text.primary
  const secondary = theme.palette.text.secondary

  return {
    gridTituloAcoes: {
      marginTop: theme.spacing(1),
      gap: theme.spacing(0.5),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    tituloAcoes: {
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
    },
    tituloAcao: {
      fontWeight: 500,
      justifyContent: 'flex-start',
    },
    tituloAcaoCenter: {
      fontWeight: 500,
      justifyContent: 'center',
      color: primary,
      padding: theme.spacing(0, 1),
    },
    disabled: {
      color: theme.palette.text.disabled,
      '&:hover': {
        borderColor: `${theme.palette.action.disabledBackground}`,
      },
    },
    tituloSecao: {
      fontWeight: 500,
      color: secondary,
    },
    secaoAcoes: {
      paddingTop: theme.spacing(1),
    },
    tooltipWrapper: {
      width: '100%',
    }
  }
})
